import { render, staticRenderFns } from "./HouseFilter.vue?vue&type=template&id=b987f442&scoped=true&"
import script from "./HouseFilter.vue?vue&type=script&lang=js&"
export * from "./HouseFilter.vue?vue&type=script&lang=js&"
import style0 from "./HouseFilter.vue?vue&type=style&index=0&id=b987f442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b987f442",
  null
  
)

export default component.exports